<template>
  <div>
    <Demo/>
    <FeaturesTheApp/>
    <PricingPlan/>
    <AppScreenshots/>
    <SomeTalkOfOurClients/>
    <SayHelloToUs/>
    <Footer/>
  </div>
</template>

<script>
import Demo from './components/Demo.vue'
import FeaturesTheApp from './components/FeaturesTheApp.vue'
import PricingPlan from './components/PricingPlan.vue'
import AppScreenshots from './components/AppScreenshots.vue'
import SomeTalkOfOurClients from './components/SomeTalkOfOurClients.vue'
import SayHelloToUs from './components/SayHelloToUs.vue'
import Footer from './components/Footer.vue'


export default {
  
    components: {
    Demo,
    FeaturesTheApp,
    PricingPlan,
    AppScreenshots,
    SomeTalkOfOurClients,
    SayHelloToUs,
    Footer
  }
}
</script>

<style>

</style>
